type ClearTableStateOptions = {
  /**
   * Şirket değişiminde tablo state'lerini sıfırlamak için.
   * Bu liste, projede "filterKey" ile ilgisi olup isimlendirmesi "filter" içermeyen anahtarları kapsar.
   */
  extraKeysToClear?: string[];
};

const DEFAULT_EXTRA_KEYS: string[] = [
  // columnVisibilityConfigKey olarak kullanılıp "filter" içermeyenler
  'mealAllowanceDetail',
  // approvals sayfalarında visibility key'leri
  'sent-approval-list',
  'approved-rejected-list',
  'makerChecker-list',
];

function shouldClearKey(key: string, extraKeysToClear: string[]): boolean {
  if (!key) return false;
  if (key === 'currentUser') return false;

  if (key.endsWith('-selected')) return true;
  if (key.includes('ColumnVisibilityKey')) return true;

  // Table.tsx / listTable.tsx filterKey isimleri genelde "Filter/filter" içeriyor
  if (key.includes('Filter') || key.includes('filter')) return true;

  // Bazı columnVisibilityConfigKey'ler "filter" içermiyor
  if (extraKeysToClear.includes(key)) return true;

  return false;
}

export function clearTableStateStorage(options?: ClearTableStateOptions) {
  const extraKeysToClear = [...DEFAULT_EXTRA_KEYS, ...(options?.extraKeysToClear ?? [])];

  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k) keys.push(k);
    }

    keys.forEach((k) => {
      if (shouldClearKey(k, extraKeysToClear)) {
        localStorage.removeItem(k);
      }
    });
  } catch {
    // localStorage erişimi engellenirse sessizce geç (örn. private mode / policy)
  }
}

